import {createSelector} from 'reselect';
import {getSettings} from '../selectors';

export default (deliveryOptionId) => createSelector(
  [getSettings],
  (settings) => {
    if (settings[`site_specific_delivery_key_for_${deliveryOptionId}`]) {
      return settings[`site_specific_delivery_key_for_${deliveryOptionId}`]?.additionalAdvice || '';
    }
    
    return '';
  },
);
